import React, { useState } from "react";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import CS from "../../../services/commonService";
import Breadcrumbs from "../../common/breadcrumbs";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import { Link, useNavigate } from "react-router-dom";
import RenderUser from "../../common/User";
import Icon from "../../icons";
import ReactTooltip from "react-tooltip";
import qs from "qs";
import {
	useGetContentReports,
	useGetCoreReportTypes,
	useGetReportReasons,
} from "../../../queryHooks";
import { useEffect } from "react";
import { URL } from "../../../constants/URL";
import { useStore } from "../../../zustand/store";
import { modules } from "../../../constants/Modules";

const columnKey = "reports";

const ContentReports = () => {
	const navigate = useNavigate();
	const lastPageData = useStore((state) => state.lastPageData);
	const setLastPageData = useStore((state) => state.setLastPageData);
	const [tableData, setTableData] = useState([]);
	const [pageNow, setPageNow] = useState(
		lastPageData?.[modules.contentReports]?.page || 1
	);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[modules.contentReports]?.items_per_page || 10
	);
	const [reasonsOptions, setReasonsOptions] = useState([]);
	const [typesOptions, setTypesOptions] = useState([]);
	const [payload, setPayload] = useState(
		lastPageData?.[modules.contentReports] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			sort: { created_at: "DESC" },
		}
	);

	const { data: coreReportTypes } = useGetCoreReportTypes();

	useEffect(() => {
		if (coreReportTypes?.status === "success") {
			let options = [];
			coreReportTypes?.data?.reporting_types?.forEach((element) => {
				options.push({ label: element?.label, value: element?.id });
			});
			setTypesOptions(options);
		}
	}, [coreReportTypes]);

	const { data: reportReasonsData } = useGetReportReasons();

	useEffect(() => {
		if (reportReasonsData?.status === "success") {
			let options = [];
			reportReasonsData?.data?.records?.forEach((data) => {
				options.push({
					label: data?.label,
					value: data?.id,
				});
			});
			setReasonsOptions(options);
		}
	}, [reportReasonsData]);

	const { data: contentReportsData, isLoading } = useGetContentReports(
		qs.stringify(payload)
	);

	useEffect(() => {
		if (contentReportsData?.status === "success") {
			let respData = contentReportsData?.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [contentReportsData]);

	const columns = [
		{
			label: "Reporter",
			type: "string",
			path: "reporter",
			alias: "first_name",
			// sort: true,
			content: (item) => (
				<Link
					to={`${URL.onboarderedUsers}/${item?.reporter?.id}`}
					onClick={() => {
						setLastPageData({ [modules.contentReports]: payload });
					}}
				>
					<RenderUser
						profileImageUrl={item?.reporter?.profile_image_url}
						firstName={item?.reporter?.first_name}
						lastName={item?.reporter?.last_name}
					/>
				</Link>
			),
		},
		{
			label: "Reportee",
			type: "string",
			path: "reportee",
			alias: "first_name",
			// sort: true,
			content: (item) => (
				<Link
					to={`${URL.onboarderedUsers}/${item?.reportee?.id}`}
					onClick={() => {
						setLastPageData({ [modules.contentReports]: payload });
					}}
				>
					<RenderUser
						profileImageUrl={item?.reportee?.profile_image_url}
						firstName={item?.reportee?.first_name}
						lastName={item?.reportee?.last_name}
					/>
				</Link>
			),
		},
		{
			label: "Reason",
			type: "string",
			path: "report_reason",
			aliasFilter: "report_reason_id",
			filterOptions: reasonsOptions,
			content: (item) => <p>{item?.report_reason?.label}</p>,
		},
		{
			label: "Type",
			type: "string",
			path: "type",
			aliasFilter: "report_type_id",
			filterOptions: typesOptions,
			content: (item) => <p>{item?.report_type?.label}</p>,
		},
		{
			label: "Status",
			type: "boolean",
			aliasFilter: "status",
			filterOptions: [
				{ label: "Opened", value: "OPEN" },
				{ label: "Closed", value: "CLOSED" },
			],
			content: (item) =>
				item?.status === "OPEN" ? (
					<p className="badge badge-light-warning mb-0">{item?.status}</p>
				) : item?.status === "CLOSED" ? (
					<p className="badge badge-light-success">{item?.status}</p>
				) : (
					<p className="badge badge-light-warning mb-0">{item?.status}</p>
				),
		},
		{
			label: "Created At",
			type: "date",
			sort: true,
			path: "created_at",
			alias: "created_at",
			filterDate: true,
			content: (item) => getCurrentTimezoneDate(item?.created_at),
		},
		{
			label: "Resolved At",
			type: "date",
			sort: true,
			path: "resolved_at",
			alias: "resolved_at",
			filterDate: true,
			content: (item) =>
				item?.resolved_at ? (
					getCurrentTimezoneDate(item?.resolved_at)
				) : (
					<p className="center">-</p>
				),
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="show"
						data-tip
						data-for="show"
						onClick={() => {
							setLastPageData({ [modules.contentReports]: payload });
							navigate(`${URL.contentReporting}/${item?.id}`);
						}}
					/>
					<ReactTooltip id="show" place="top" effect="solid">
						Show
					</ReactTooltip>
				</>
			),
		},
	];

	return (
		<>
			<Breadcrumbs
				title="Content Reporting"
				data={[{ label: "Content Reports" }]}
			/>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												searchValue={
													lastPageData?.[modules.contentReports]?.search
														?.first_name
												}
												search={(value) => {
													setPageNow(1);
													setPayload({
														...payload,
														search: {
															first_name:
																!value && value === "" ? undefined : value,
															last_name:
																!value && value === "" ? undefined : value,
															username:
																!value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
								</div>
							</div>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								payload={payload}
								sortCol={(obj) => {
									setPageNow(1);
									setPayload({
										...payload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setPayload({
										...payload,
										page,
									});
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setPayload({
										...payload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(payload.filter, obj);
										setPageNow(1);
										setPayload({
											...payload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setPayload({
											...payload,
											filter: {
												...payload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setPayload({
										...payload,
										filter_date: dates && {
											...payload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ContentReports;
